<template>
  <div class="wizzard">
    <component v-bind:is="stepComponent" :step="step"></component>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";

import step1 from "@/components/busquedaAvanzada/step1.vue";
import step1a from "@/components/busquedaAvanzada/step1a.vue";
import step2 from "@/components/busquedaAvanzada/step2.vue";
import step3 from "@/components/busquedaAvanzada/step3.vue";
import step4 from "@/components/busquedaAvanzada/step4.vue";
export default {
  name: "wizzardbusqueda",
  components: {
    step1,
    step2,
    step1a,
    step3,
    step4
  },
  data: () => ({
    stepComponent: ""
  }),
  props: ["step"],
  watch: {
    step(val) {
      console.log("hi");
      console.log(val);
      this.stepComponent = this.step;
    }
  },
  methods: {},

  beforeMount() {
    //this.$store.commit("resetBackData"); //naye
  },
  mounted() {
    console.log(this.step);
    this.stepComponent = this.step;
  },
  methods: {},
  updated() {}
};
</script>

<style lang="scss">
.fil1 {
  fill: #fefefe;
  fill-rule: nonzero;
}
.fil0 {
  fill: #00b99e;
  fill-rule: nonzero;
}

.card {
  overflow: visible !important;
}

.vue__time-picker .dropdown .select-list {
  width: 100% !important;
}

.time-section .select-container .select-list {
  padding: 0% !important;
  border: none !important;
}

</style>
